import React from "react";
import {
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Box,
} from "@mui/material";
import { LogOut } from "lucide-react";

export default function LogoutConfirmationModal({ open, onClose, onConfirm }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 2,
                },
            }}
        >
            <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
                <Stack alignItems="center" spacing={1}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, #EF4444 0%, #F97316 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <LogOut size={28} color="#fff" />
                    </Box>
                    <Typography variant="h6" fontWeight="bold">
                        Confirm Logout
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                    Are you sure you want to logout? You'll need to sign in again to access your account.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 1 }}>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        px: 4,
                        background: "linear-gradient(to right, #EF4444, #F97316)",
                        "&:hover": {
                            background: "linear-gradient(to right, #DC2626, #EA580C)",
                        },
                    }}
                >
                    Logout
                </Button>
                <Button
                    variant="text"
                    onClick={onClose}
                    sx={{ textTransform: "none", color: "text.secondary" }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}

